export interface VifTileDataset {
  topEQs: string[];
  bottomAnswers: string[];
  tEqValues: (string | number)[];
}

const addLayer1: VifTileDataset = {
  topEQs: [
    '2 + 2',
    '2 + 3',
    '3 + 3',
    '2 + 4',
    '3 + 4',
    '4 + 4',
    '2 + 5',
    '3 + 5',
    '4 + 5',
    '5 + 5',
    '2 + 6',
    '3 + 6',
    '4 + 6',
    '2 + 7',
    '3 + 7',
    '2 + 8',
  ],
  bottomAnswers: [
    '4',
    '5',
    '6',
    '6',
    '7',
    '8',
    '7',
    '8',
    '9',
    '10',
    '8',
    '9',
    '10',
    '9',
    '10',
    '10',
  ],
  tEqValues: [
    '4',
    '5',
    '6',
    '6',
    '7',
    '8',
    '7',
    '8',
    '9',
    '10',
    '8',
    '9',
    '10',
    '9',
    '10',
    '10',
  ],
};

const addPatternGroupA: VifTileDataset = {
  topEQs: [
    '9 + 1',
    '6 + 4',
    '9 + 0',
    '7 + 2',
    '0 + 8',
    '7 + 1',
    '1 + 6',
    '4 + 3',
    '0 + 6',
    '1 + 4',
    '3 + 2',
    '5 + 0',
    '0 + 3',
    '2 + 1',
    '0 + 2',
    '0 + 1',
  ],
  bottomAnswers: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '5',
    '5',
    '5',
    '3',
    '3',
    '2',
    '1',
  ],
  tEqValues: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '5',
    '5',
    '5',
    '3',
    '3',
    '2',
    '1',
  ],
};

const addPatternGroupB: VifTileDataset = {
  topEQs: [
    '7 + 3',
    '1 + 9',
    '5 + 4',
    '8 + 1',
    '1 + 7',
    '6 + 2',
    '0 + 7',
    '7 + 0',
    '4 + 2',
    '6 + 0',
    '0 + 5',
    '1 + 3',
    '3 + 1',
    '3 + 0',
    '1 + 1',
    '0 + 0',
  ],
  bottomAnswers: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '6',
    '5',
    '4',
    '4',
    '3',
    '2',
    '0',
  ],
  tEqValues: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '6',
    '5',
    '4',
    '4',
    '3',
    '2',
    '0',
  ],
};

const addPatternGroupC: VifTileDataset = {
  topEQs: [
    '8 + 2',
    '0 + 9',
    '6 + 3',
    '1 + 8',
    '5 + 3',
    '8 + 0',
    '5 + 2',
    '6 + 1',
    '1 + 5',
    '5 + 1',
    '4 + 1',
    '0 + 4',
    '4 + 0',
    '1 + 2',
    '2 + 0',
    '1 + 0',
  ],
  bottomAnswers: [
    '10',
    '9',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '6',
    '5',
    '4',
    '4',
    '3',
    '2',
    '1',
  ],
  tEqValues: [
    '10',
    '9',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '6',
    '5',
    '4',
    '4',
    '3',
    '2',
    '1',
  ],
};

const subLayer1: VifTileDataset = {
  topEQs: [
    '4 - 2',
    '5 - 2',
    '6 - 3',
    '6 - 2',
    '7 - 3',
    '8 - 4',
    '7 - 2',
    '8 - 3',
    '9 - 4',
    '10 - 5',
    '8 - 2',
    '9 - 3',
    '10 - 4',
    '9 - 2',
    '10 - 3',
    '10 - 2',
  ],
  bottomAnswers: [
    '2',
    '3',
    '3',
    '4',
    '4',
    '4',
    '5',
    '5',
    '5',
    '5',
    '6',
    '6',
    '6',
    '7',
    '7',
    '8',
  ],
  tEqValues: [
    '2',
    '3',
    '3',
    '4',
    '4',
    '4',
    '5',
    '5',
    '5',
    '5',
    '6',
    '6',
    '6',
    '7',
    '7',
    '8',
  ],
};

// NOTE: bottomAnswers and tEqValues intentionally differ in this dataset (verbatim from source).
const subPatternGroupA: VifTileDataset = {
  topEQs: [
    '0 - 0',
    '3 - 3',
    '6 - 6',
    '9 - 9',
    '2 - 1',
    '7 - 6',
    '8 - 7',
    '2 - 0',
    '5 - 3',
    '7 - 5',
    '4 - 1',
    '8 - 5',
    '10 - 6',
    '6 - 0',
    '8 - 1',
    '9 - 0',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '6',
    '7',
    '9',
  ],
  tEqValues: [
    '10',
    '10',
    '9',
    '9',
    '8',
    '8',
    '7',
    '7',
    '6',
    '5',
    '5',
    '5',
    '3',
    '3',
    '2',
    '1',
  ],
};

const subPatternGroupB: VifTileDataset = {
  topEQs: [
    '1 - 1',
    '4 - 4',
    '7 - 7',
    '3 - 2',
    '5 - 4',
    '6 - 5',
    '10 - 9',
    '8 - 6',
    '9 - 7',
    '7 - 4',
    '10 - 7',
    '4 - 0',
    '9 - 5',
    '5 - 0',
    '7 - 1',
    '9 - 1',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '1',
    '2',
    '2',
    '3',
    '3',
    '4',
    '4',
    '5',
    '6',
    '8',
  ],
  tEqValues: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '1',
    '2',
    '2',
    '3',
    '3',
    '4',
    '4',
    '5',
    '6',
    '8',
  ],
};

const subPatternGroupC: VifTileDataset = {
  topEQs: [
    '2 - 2',
    '5 - 5',
    '8 - 8',
    '1 - 0',
    '4 - 3',
    '9 - 8',
    '3 - 1',
    '6 - 4',
    '10 - 8',
    '3 - 0',
    '9 - 6',
    '5 - 1',
    '6 - 1',
    '7 - 0',
    '8 - 0',
    '10 - 1',
  ],
  bottomAnswers: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '5',
    '7',
    '8',
    '9',
  ],
  tEqValues: [
    '0',
    '0',
    '0',
    '1',
    '1',
    '1',
    '2',
    '2',
    '2',
    '3',
    '3',
    '4',
    '5',
    '7',
    '8',
    '9',
  ],
};

export const VIF_ADD_SUB_DATA = {
  add: {
    layer1: addLayer1,
    patternGroupA: addPatternGroupA,
    patternGroupB: addPatternGroupB,
    patternGroupC: addPatternGroupC,
  },
  sub: {
    layer1: subLayer1,
    patternGroupA: subPatternGroupA,
    patternGroupB: subPatternGroupB,
    patternGroupC: subPatternGroupC,
  },
};
